import { z } from 'zod'
import { QUARTERS, type Quarter } from '@/config/cbamReportingPeriods'

export type CbamSimulationGoodFormData = {
  aggregatedGoodsCategory?: string
  cnCode: string
  country: string
  description?: string | null
  netMassInTonnes: number
  isUsingDefaultEmissions: boolean
  supplierEmissionsReportId?: string | null
  importDate: string
  quarter?: Quarter | null
}

const quarterSchema = z.enum(QUARTERS)

const cbamSimulationGoodFormSchema = z.object({
  aggregatedGoodsCategory: z.string().optional(),
  cnCode: z.string().min(1),
  country: z.string().min(1),
  description: z.string().nullable().optional(),
  netMassInTonnes: z.number().gt(0),
  isUsingDefaultEmissions: z.boolean(),
  supplierEmissionsReportId: z.string().nullable().optional(),
  importDate: z.string().min(1),
  quarter: quarterSchema.nullable().optional()
})

export const validateCbamSimulationGoodForm = (data: CbamSimulationGoodFormData) => {
  return cbamSimulationGoodFormSchema.safeParse(data)
}
